import request from './request';

/**
 * 执行和结果API - V2
 */

// ============ 执行相关 ============

// 获取执行列表
export function getExecutions(params) {
  return request({
    url: '/eval/executions',
    method: 'get',
    params
  });
}

// 获取执行详情
export function getExecutionDetail(id) {
  return request({
    url: `/eval/executions/${id}`,
    method: 'get'
  });
}

// 重试执行
export function retryExecution(id) {
  return request({
    url: `/eval/executions/${id}/retry`,
    method: 'post'
  });
}

// ============ 结果相关 ============

// 获取结果列表
export function getResults(params) {
  return request({
    url: '/eval/results',
    method: 'get',
    params
  });
}

// 获取执行结果列表（别名，与getResults相同）
export function getExecutionResults(params) {
  return request({
    url: '/eval/results',
    method: 'get',
    params
  });
}

// 获取结果详情
export function getResultDetail(id) {
  return request({
    url: `/eval/results/${id}`,
    method: 'get'
  });
}

// 手动评分
export function manualScore(id, data) {
  return request({
    url: `/eval/results/${id}/manual-score`,
    method: 'post',
    data
  });
}

// 触发自动评分
export function triggerAutoScore(id) {
  return request({
    url: `/eval/results/${id}/auto-score`,
    method: 'post'
  });
}

// 单个结果自动评分（别名）
export function autoScoreSingle(id) {
  return request({
    url: `/eval/results/${id}/auto-score`,
    method: 'post'
  });
}

// 批量自动评分
export function batchAutoScore(testPlanId) {
  return request({
    url: '/eval/results/batch-auto-score',
    method: 'post',
    data: { test_plan_id: testPlanId }
  });
}

// 标记问题
export function markIssues(id, data) {
  return request({
    url: `/eval/results/${id}/issues`,
    method: 'post',
    data
  });
}

// 获取结果统计
export function getResultStatistics(testPlanId) {
  return request({
    url: `/eval/results/statistics/${testPlanId}`,
    method: 'get'
  });
}

